module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Filter"
  }, [(_vm.template == "participants") ? [_c('participants', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "FILTER_CHANGE": _vm.onChange,
      "FILTER_CHANGE_PAYLOAD": _vm.onChangePayload
    }
  })] : [_vm._v("\n\t\tUnknown filter template: "), _c('b', [_vm._v(_vm._s(_vm.template))])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361c596e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/Filters.vue
// module id = 242
// module chunks = 35